/*
window.addEventListener("dx_init", function(){  
    dx_contactforms_init();
});
*/
if(window.parent==window){
    window.addEventListener("load", function(){
        dx_contactforms_init();
    });    
}  
window.addEventListener(" dx_contactform_init", function(event){ 
    dx_contactform_init(event.detail.block);
});

function dx_contactforms_init(){
    var blocks = document.getElementsByClassName("wp-block-dx-contact-form"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_contactform_init(blocks[i]);               
    }   
}    

function dx_contactform_init(block){
    if(block.getAttribute("data-init")=="1"){
        return;
    }
    block.setAttribute("data-init", "1");

    block.getElementsByTagName("button")[0].onclick=function(event){
        var inputs={};
        inputs.name=event.currentTarget.parentNode.getElementsByTagName('input')[0];
        inputs.email=event.currentTarget.parentNode.getElementsByTagName('input')[1];
        inputs.message=event.currentTarget.parentNode.getElementsByTagName('textarea')[0];
        
        if(inputs.name.value=="" || inputs.email.value=="" || inputs.message.value==""){
            alert("Bitte überprüfen Sie Ihre Eingaben.");
            return;
        }

        var xhttp = new XMLHttpRequest(); 
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4) {
                if(this.status == 200){
                    console.log(this.response);
                    inputs.name.value="";
                    inputs.email.value="";
                    inputs.message.value="";
                    alert("Die Nachricht wurde gesendet.");
                } else {
                    alert("Beim Sender Ihrer Nachricht ist ein Fehler aufgetreten ("+this.status+")");
                }
            }
        };
        xhttp.open("POST", Dx.url.root+"/wp-content/plugins/dx/mail.php", true);

        var data = new FormData();
        data.append('name', inputs.name.value);
        data.append('email', inputs.email.value);
        data.append('message', inputs.message.value);
        xhttp.send(data);
    }
}

/*
function dx_contactforms_update(){
    var blocks = document.getElementsByClassName("wp-block-dx-contact-from"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_contactform_update(blocks[i]);               
    }  
}   

function dx_contactform_update(block){
    
}
*/
  
